export function convertAllocationsToObject(
  allocations: Array<{ activityId: string; allocation: number }>
): Record<string, number> {
  return allocations.reduce(
    (acc, item) => {
      acc[item.activityId] = item.allocation;
      return acc;
    },
    {} as Record<string, number>
  );
}
export default convertAllocationsToObject;
